import React, { useEffect, useState } from "react";
import { ChevronLeft, Sun, Moon, CloudRain, Sunset } from "lucide-react";
import { phaseLabel } from "../../lib/trafficCore";
import { jamWIB } from "../../lib/sky";
import { pill, roundBtn, SAFE_TOP, GLASS, namaKota } from "./ui";

// Urutan mode langit saat pil jam diketuk: Otomatis (ikut jam nyata WIB) → Siang → Malam → Hujan → Otomatis
export const SKY_CYCLE = { real: "day", auto: "day", day: "night", night: "rain", rain: "real" };
const SKY_LABEL = { real: "Otomatis · ikut jam WIB", auto: "Siang", day: "Siang", night: "Malam", rain: "Hujan" };
const WARNA = { day: "#d9a21b", night: "#9f9fff", rain: "#6f93b8", senja: "#e8894a" };

// Ikon mode otomatis mengikuti fase jam WIB saat ini (matahari / senja-fajar / bulan)
function ikonOtomatis(h) {
  if (h >= 19 || h < 4.5) return [Moon, WARNA.night];
  if (h >= 17 || h < 6.5) return [Sunset, WARNA.senja];
  return [Sun, WARNA.day];
}

// Bar atas kaca: kiri = kembali ke pulau + nama kota; kanan = jam kota + ikon langit (ketuk → ganti langit)
export function TopBar({ cityId, engineRef, skyMode, onSky }) {
  const [clock, setClock] = useState({ txt: "--:--", phase: "", h: jamWIB() });
  useEffect(() => {
    const tick = () => {
      const h = engineRef.current?.city?.hour;
      if (h == null) return;
      const hh = Math.floor(h), mm = Math.floor((h - hh) * 60);
      setClock({ txt: `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`, phase: phaseLabel(h), h: jamWIB() });
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [engineRef]);
  const otomatis = skyMode === "real" || skyMode === "auto";
  const [Icon, warna] = otomatis ? ikonOtomatis(clock.h) : skyMode === "night" ? [Moon, WARNA.night] : skyMode === "rain" ? [CloudRain, WARNA.rain] : [Sun, WARNA.day];
  return (
    <div data-testid="kota-topbar" style={{ position: "absolute", left: 12, right: 12, top: `calc(${SAFE_TOP} + 12px)`, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, pointerEvents: "none" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
        <a href="/" data-testid="back-to-map" aria-label="Kembali ke peta Jawsel" style={{ ...roundBtn(false), width: 38, height: 38, pointerEvents: "auto", textDecoration: "none" }}>
          <ChevronLeft size={18} strokeWidth={2} />
        </a>
        <div data-testid="kota-title" style={{ ...pill, pointerEvents: "auto", minWidth: 0 }}>
          <span style={{ width: 6, height: 6, borderRadius: 99, background: GLASS.accent, flex: "none", boxShadow: "0 0 0 3px var(--g-accent-bg)" }} />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>Kota {namaKota(cityId)}</span>
        </div>
      </div>
      <button data-testid="kota-clock" data-sky={skyMode} title={`${clock.phase} · ketuk untuk ganti langit (${SKY_LABEL[skyMode] || "Siang"})`} onClick={onSky}
        style={{ ...pill, pointerEvents: "auto", gap: 7, paddingLeft: 11, cursor: "pointer" }}>
        <Icon size={15} strokeWidth={2} color={warna} />
        <span style={{ fontVariantNumeric: "tabular-nums" }}>{clock.txt}</span>
        {otomatis && <span data-testid="kota-sky-auto" style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: 0.6, color: GLASS.sub, padding: "2px 6px", borderRadius: 99, background: "var(--g-inner)" }}>WIB</span>}
      </button>
    </div>
  );
}
